// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0d396e',
            light: '#41d0e2',
            dark: '#2785a9',
            contrastText: '#fff',
        },
        secondary: {
            main: '#00cc98', // Beispiel: Orange
        },
    },
});

export default theme;